<template>
<div id="app" class="flex">
	<Navbar />
	<router-view></router-view>
    <TheFooter />
</div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import TheFooter from '@/components/TheFooter.vue';

export default {
	name: 'app',
	components: {
		Navbar,
        TheFooter
	},
}
</script>

<style>

/* Element Stylings */

*, *::before, *::after
{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Montserrat', sans-serif;
}

html { overflow-x: hidden; height: 100%; }

body { height: 100%; }

h1, h2, h3, h4, h5, h6 { font-weight: normal; }

ul { list-style-type: none; }

a { text-decoration: none; }

i { font-style: normal; }

img { display: block; }

/* General Stylings */

html.no-scroll { overflow: hidden; }

.container
{
	width: calc(100% - 30px);
    max-width: 1200px;
    margin: 0 auto;
}

.flex
{
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
}

.wrap { flex-wrap: wrap; }

.center
{
    align-items: center;
    justify-content: center;
}

.align-center { align-items: center; }

.justify-btw { justify-content: space-between; }

.justify-evenly { justify-content: space-evenly; }

.btn
{
    border: 0;
    outline: 0;
    cursor: pointer;
    position: relative;
    z-index: 1;
}

.fancy-btn::after
{
    content: "";
    position: absolute;
    top: 0; left: 0;
    z-index: -1;
    width: 100%; height: 100%;
    background-color: rgb(0, 0, 0,0.5);
    border-radius: inherit;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.3s ease-out;
}

.fancy-btn:hover::after, .fancy-btn:focus::after { transform: scaleX(1); }

.d-none { display: none !important; }

.icon-sprite
{
	background-image: url('./assets/icon_sprite.png');
	background-size: 402px 142px;
}

.section
{
    padding: 60px 0 75px;
    background-image: url('./assets/Goemetirc Textures.png');
}

.sub-headings
{
    font-family: 'Josefin Sans', sans-serif;
    font-size: 30px;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 25px;
}

.main-headings
{
    font-family: 'Josefin Sans', sans-serif;
    font-weight: 900;
    font-size: 35px;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 40px;
    position: relative;
    color: #00c7ff;
}

.main-headings::after
{
    position: absolute;
    content: '';
    bottom: -10px; left: 50%;
    transform: translateX(-50%);
    height: 5px; width: 80px;
    background-color: rgb(0, 199, 255, 0.75);
}

.primary-text
{
    font-size: 15px;
    line-height: 1.8;
    font-weight: 500;
    margin-bottom: 20px;
    text-align: justify;
}

ul.list { margin: 25px 0; }

ul.list:last-child { margin-bottom: 0; }

ul.list li
{
    position: relative;
    padding-left: 50px;
    font-size: 15px;
    line-height: 1.8;
    font-weight: 500;
    margin-bottom: 10px;
}

ul.list li::before
{
    content: '';
    display: inline-block;
    background-image: url('./assets/icon_sprite.png');
    background-position: -136.8px -66.2px;
	height: 18px; width: 18px;
    background-size: 289.4px 102.2px;
    position: absolute;
    top: 5px; left: 15px;
}

p.primary-text:last-child, ul.list li:last-child { margin-bottom: 0 !important; }

.error-parent
{
    position: relative;
    margin-bottom: 20px;
}

p.error-msg, p.info-msg
{
    font-weight: 600;
    font-size: 1rem;
    margin-top: 15px;
}

p.error-msg { color: #E20613; }

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  -webkit-animation: spinner-border .75s linear infinite;
  animation: spinner-border .75s linear infinite;
}

@-webkit-keyframes spinner-border {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes spinner-border {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

/* Local Stylings */

#app
{
    flex-direction: column;
    min-height: 100%;
    padding-top: 80px;
}

@media only screen and  (max-device-width: 767px)
{
    h2.sub-headings
    {
        font-size: 24px;
        text-align: center;
        line-height: 1.75;
        padding: 12px 20px 12px 25px;
        margin: 0 auto 40px;
    }

    h3.main-headings { font-size: 24px; line-height: 2; }

    p.primary-text { text-align: left; }
}

</style>